export default {
  currentUserMessage: {}
}